import type { SVGProps } from 'react'

export function PayPalIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.773.773 0 0 1 .763-.646h6.636c2.245 0 3.868.503 4.826 1.495.935.969 1.28 2.412.996 4.166-.018.112-.04.216-.057.324l-.006.036v.282l.219.126c.176.103.339.22.486.356.38.354.653.796.81 1.312.164.54.211 1.168.14 1.871-.08.8-.278 1.516-.594 2.134a4.42 4.42 0 0 1-1.108 1.437c-.45.378-.986.67-1.592.864a7.174 7.174 0 0 1-2.08.284h-.493a1.003 1.003 0 0 0-.992.852l-.038.217-.64 4.074-.029.15a.133.133 0 0 1-.033.07.075.075 0 0 1-.056.023H7.076z" />
      <path
        d="M18.218 8.055c-.013.08-.026.163-.042.247-.549 2.816-2.428 3.79-4.828 3.79H12.02a.594.594 0 0 0-.587.503l-.715 4.527-.203 1.286a.312.312 0 0 0 .308.362h2.166c.257 0 .476-.187.517-.442l.021-.11.41-2.602.026-.143a.52.52 0 0 1 .516-.442h.325c2.107 0 3.756-.856 4.239-3.331.202-1.035.097-1.9-.437-2.507a2.083 2.083 0 0 0-.588-.437l.001-.001z"
        opacity=".7"
      />
    </svg>
  )
}
